module.exports = __webpack_public_path__ + "img/bbl.b281151b.svg";